import { Toaster, useId, useToastController } from "@fluentui/react-components";
import { useEffect, useState } from "react";

import { useRootStore } from "store";
import { NotificationToast } from "./NotificationToast";

import "./ToasterNotification.scss";

export function ToasterNotification() {
  const { data, removeNotification } = useRootStore((state) => state.toastNotifications)
  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);
  const [displayedToastIds, setDisplayedToastIds] = useState<string[]>([]);

  useEffect(() => {
    data.forEach((message) => {
      if (
        displayedToastIds.includes(message.id)
      ) {
        return null;
      }

      const { type: intent } = message;
      const position = "top-end";

      dispatchToast(
        <NotificationToast
          key={message.id}
          message={message}
          onDismiss={(id: string) =>
            removeNotification(id)
          }
          notificationActionText={message.message}
        />,
        { position, intent }
      );

      setDisplayedToastIds((prev) => [...prev, message.id]);
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dispatchToast, displayedToastIds]);

  return <Toaster toasterId={toasterId} className="toaster" />;
}
